import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.png'

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'cnl';

  useEffect(() => {
    setShowForm(true);
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "Senha incorreta. Tente novamente ou redefina sua senha na central do assinante.";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-cnl-container" ref={nodeRef}>
        <Form onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="cnl-form-container">
            <img src={logo} alt="logo" className="logo-cnl rounded mx-auto d-block" />
            <Row className="cnl-form-body">
              <Col sm="12" xs="12" md="12" className="cnl-input">
                <h3>Acesse pela ConesulTV</h3>
                <Input
                  className="user-input-cnl"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  onChange={e => setUsername(e.target.value)}
                  placeholder={translate("PlaceholderUserName")}
                />
              </Col>
              <Col sm="12" xs="12" md="12" className="cnl-input">
                <Input
                  className="pass-input-cnl"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeholder={translate("PlaceholderPassword")}
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
              <Col sm="12" xs="12" md="12" className="cnl-input" style={{ textAlign: 'left', margin: '20px 0px' }}>
                <label style={{ fontWeight: '100' }}><input type="checkbox" id="cbox1" value="first_checkbox" /> Lembrar meus dados</label>
              </Col>
              <Col sm="12" xs="12" md="12" className="cnl-input">
                {!onLogin ? (
                  <button
                    block={!parameters.failureRedirect}
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="enter-cnl"
                    disabled={!props.turnstileSuccess}
                  >
                    {translate("ButtonEnter")}
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </Col>
            </Row>
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
          </Container>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm);
